import { QueryFunctionContext } from 'react-query'
import request from 'services/axios'

export const getSettlements = async (
    pageParam: number,
    moneyPool: string | undefined
) => {
    const { data }: { data: ISettlements } = await request.get(
        `/api/v1/moneypools/${moneyPool}/exit-request/?page=${pageParam}`
    )
    return data
}

export const DeleteMySettlement = async (payload: number) => {
    const response = await request.delete(
        `/api/v1/moneypools/${payload}/exit-request/`
    )
    return response
}
export const setSettlement = async (payload: ISetSettlementPayload) => {
    const { data } = await request.post(
        `/api/v1/moneypools/${payload.id}/exit-request/`,
        {
            ...payload,
        }
    )
    return data
}

export const getAdminSettlements = async (
    pageParam: number,
    moneyPool: string | undefined
) => {
    const { data }: { data: IAdminSettlements } = await request.get(
        `/api/v1/moneypools/${moneyPool}/admin-exit-request/?page=${pageParam}`
    )
    return data
}
export const getAdminSettlementsPost = async (
    payload: getAdminSettlementsPostPayload
) => {
    const { data } = await request.post(
        `/api/v1/moneypools/${payload.moneyPool}/admin-exit-request/`,
        {
            exit_request_id: payload.id,
        }
    )
    return data
}
export const getInitSettlement = async (ctx: QueryFunctionContext) => {
    if (ctx.queryKey[1]) {
        const { data }: { data: IGetCards } = await request.post(
            '/api/v1/payment/init/?os_type=android&app_version=1.892.9',
            [
                {
                    id: ctx.queryKey[1],
                    type: 'psp',
                    amount: 0,
                    cashin_type: 'cns',
                    paid_obj_id: 0,
                },
            ]
        )
        return data
    }
}

export const getSettlementCheckStatus = async (
    payload: IGetSettlementCheckStatusPayload
) => {
    const { data }: { data: IGetSettlementCheckStatusResponse } =
        await request.get(
            `/api/v1/moneypools/${payload.moneyPool}/poolships/${payload.poolShip}/checkout-status/`
        )
    return data
}
